module.exports = __webpack_public_path__ + "site/img/LOGO_LabourD3.3599c2ef.png";